import React from "react";
import { Link } from "react-router-dom";
import jobData from "./RequestedJobData/requestedData";
import Rates from "../Rates/Rates";

function Services({ handleScheduleClick }) {
  return (
    <div className="with-navbar-offset">
      <div className="top-bar-wrapper enhanced-top-bar">
        <div className="container">
          <div className="row">
            <div className="col-12 top-bar-info-main enhanced-top-bar-info">
              <span className="lincensed-para enhanced-top-bar-text">
                ⭐ Not a licensed contractor
              </span>
            </div>
          </div>
        </div>
      </div>

      <section className="services-hero-section bg-dark text-white py-5 position-relative">
        <div className="container position-relative z-2">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="hero-badge mb-3">
                <span>New Lower Rates</span>
              </div>
              <h1 className="display-4 fw-bold mb-3">
                Over 12,500 Jobs. Just 6,000 Customers. That Says Everything.
              </h1>
              <p className="lead mb-4">
                We've completed over 12,500 jobs for just 6,037 customers —
                because they keep coming back.
                <br />
                Now, in a time of inflation and uncertainty, we're stepping up
                again with new, lower pricing:
                <br />
                <span className="fw-bold text-warning">
                  $79 for your first hour. $69/hour after that. No surprises.
                </span>
              </p>
              <div className="d-flex flex-wrap gap-3 mb-4">
                <button
                  className="btn btn-warning btn-lg"
                  onClick={handleScheduleClick}
                >
                  Book at Our New Lower Rates
                </button>
                <button
                  className="btn btn-outline-light btn-lg"
                  onClick={handleScheduleClick}
                >
                  Start with Our AI Assistant
                </button>
                <button
                  className="btn btn-light btn-lg text-dark"
                  onClick={handleScheduleClick}
                >
                  Schedule Real Help in Minutes
                </button>
              </div>
              <div className="d-flex gap-4 align-items-center mt-3">
                <div className="text-center">
                  <div
                    className="fw-bold text-warning"
                    style={{ fontSize: "1.5rem" }}
                  >
                    12,500+
                  </div>
                  <div className="small">Verified Jobs</div>
                </div>
                <div className="vr bg-light" style={{ height: "40px" }}></div>
                <div className="text-center">
                  <div
                    className="fw-bold text-warning"
                    style={{ fontSize: "1.5rem" }}
                  >
                    6,037
                  </div>
                  <div className="small">Valued Customers</div>
                </div>
                <div className="vr bg-light" style={{ height: "40px" }}></div>
                <div className="text-center">
                  <div
                    className="fw-bold text-warning"
                    style={{ fontSize: "1.5rem" }}
                  >
                    5+
                  </div>
                  <div className="small">Years in Business</div>
                </div>
              </div>
            </div>
            <div className="col-lg-5 d-none d-lg-block">
              <img
                src="./images/rates-img.png"
                alt="Handyman at work"
                className="img-fluid rounded-4 shadow"
              />
            </div>
          </div>
        </div>
        <div
          className="services-hero-bg-overlay position-absolute top-0 start-0 w-100 h-100"
          style={{
            zIndex: 1,
            background: "linear-gradient(120deg, #232526 0%, #414345 100%)",
            opacity: 0,
            pointerEvents: "none",
          }}
        ></div>
      </section>

      <section class="py-5">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <h3 class="fs-2 fw-bold text-warning mb-5">
                General Hourly Rates
              </h3>
              <ul class="list-styled-dash">
                <li className="fs-4 mb-3">1-Person Rate:</li>
                <ul className="ms-4">
                  <li class="fs-4 mb-4">
                    First Hour: <span class="fw-bold text-warning">$79</span>
                  </li>
                  <li class="fs-4 mb-4">
                    Each Additional Hour:{" "}
                    <span class="fw-bold text-warning">$69/hour</span>
                  </li>
                </ul>
                <li className="fs-4 mb-3">2-Person Rate:</li>
                <ul className="ms-4">
                  <li className="fs-4 mb-3">
                    First Hour:{" "}
                    <span class="fw-bold text-warning">
                      $158 ($79/hr per handyman)
                    </span>
                  </li>
                  <li className="fs-4 mb-3">
                    Each Additional Hour:{" "}
                    <span class="fw-bold text-warning">
                      $138/hour ($69/hr per handyman)
                    </span>
                  </li>
                </ul>
              </ul>
              <div class="alert alert-info mt-4">
                <strong>
                  Combine multiple tasks into one visit to maximize your
                  savings!
                </strong>
                <br />
                All work is guaranteed by the on-site handyman. No payment until
                you're satisfied.
              </div>
            </div>
            <div class="col-md-6 d-flex align-items-center">
              <img
                src="./images/rates-img.png"
                alt="Rates Image"
                class="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="social-proof-section py-5 bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-10 text-center">
              <h2 className="fw-bold mb-4">
                Why Do Thousands Keep Coming Back? Because We Show Up, Do It
                Right, and Keep It Honest.
              </h2>
              <div className="d-flex flex-wrap justify-content-center gap-4 mb-4">
                <div className="text-center">
                  <div className="display-6 fw-bold text-warning">12,500+</div>
                  <div className="small">Verified Jobs</div>
                </div>
                <div className="text-center">
                  <div className="display-6 fw-bold text-warning">5+ Years</div>
                  <div className="small">In Business</div>
                </div>
                <div className="text-center">
                  <div className="display-6 fw-bold text-warning">6,037</div>
                  <div className="small">Valued Customers</div>
                </div>
                <div className="text-center">
                  <div className="display-6 fw-bold text-warning">✔</div>
                  <div className="small">Work Guaranteed</div>
                </div>
                <div className="text-center">
                  <div className="display-6 fw-bold text-warning">🕵️‍♂️</div>
                  <div className="small">Background-Checked Pros</div>
                </div>
                <div className="text-center">
                  <div className="display-6 fw-bold text-warning">💳</div>
                  <div className="small">No Payment Until Satisfied</div>
                </div>
              </div>
              <div className="d-flex flex-wrap justify-content-center gap-3">
                <button
                  className="btn btn-warning btn-lg"
                  onClick={handleScheduleClick}
                >
                  Book Now at New Rates
                </button>
                <button
                  className="btn btn-outline-dark btn-lg"
                  onClick={handleScheduleClick}
                >
                  Chat with Our AI Assistant 24/7
                </button>
                <button
                  className="btn btn-dark btn-lg"
                  onClick={handleScheduleClick}
                >
                  Fix More for Less – Start Today
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="call-to-action bg-warning py-4 px-4">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h3 className="text-dark mb-0">
                Our expert handymen are just a click away!
              </h3>
            </div>
            <div className="col-md-4 text-md-end">
              <button
                className="btn btn-dark btn-lg"
                onClick={handleScheduleClick}
              >
                Schedule Now
              </button>
            </div>
          </div>
        </div>
      </section>
      <div class="fix-it-plan-main services-page-main">
        <section class="top-requested-sect">
          <div class="container">
            <div class="row">
              <div class="col-12 top-requested-head-div">
                <div class="plans-section-head-div">
                  <h3 class="plans-sect-head-text">
                    <span className="border-yellow-bottom">
                      Top Requested Jobs
                    </span>
                  </h3>
                </div>
              </div>
              <h6>
                <p className="">Single Job Flat Rates: </p>
                <i className="text-muted">
                  If the job takes 30 minutes or less, the flat rate is $79.
                  There is no mark up on materials. The store will call the
                  owner for material payment directly.
                </i>
                <br />
                <br />
                <i className="text-warning">
                  Important: Listed times are for installation only. Add 1 hour
                  if materials need to be purchased from store.
                </i>
                <br />
                <br />
                <i>
                  Store Visit Time:{" "}
                  <span style={{ fontSize: "1.2rem" }} className="text-warning">
                    Additional 1 hour when materials need to be purchased
                  </span>
                </i>
                <br />
                <br />
                <i> *Actual Time and Materials May Vary</i>{" "}
              </h6>

              <div className="row my-5">
                <div className="col-12">
                  <div className="bg-light p-4 rounded-3 shadow-sm">
                    <div className="row align-items-center">
                      <div className="col-md-8">
                        <h4 className="text-dark mb-2">
                          Need a Quote for Your Project?
                        </h4>
                        <p className="text-muted mb-md-0">
                          Get an instant estimate for any of our services. Our
                          team is ready to help!
                        </p>
                      </div>
                      <div className="col-md-4 text-md-end">
                        <button
                          className="btn btn-warning btn-lg"
                          onClick={handleScheduleClick}
                        >
                          Get Free Estimate
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row top-requested-inner-content">
              {jobData.map((job) => {
                const needsMaterials = !job.details
                  ?.toLowerCase()
                  .includes("typically onsite");
                return (
                  <div
                    key={job.id}
                    className={`col-md-6 col-sm-12 top-requested-single-col border-btm ${job.section} mb-4`}
                  >
                    <div className="top-requested-sing-meta-div p-3">
                      <div className="row align-items-start">
                        <div className="col-1">
                          <p className="top-req-number-span font-weight-bold">
                            {job.id})
                          </p>
                        </div>
                        <div className="col-11">
                          <p
                            className="top-single-meta-text m-0 font-weight-bold"
                            style={{ fontSize: "1.5rem", color: "#333" }}
                          >
                            {job.job}
                          </p>
                          <p
                            className="top-single-meta-cost m-0"
                            style={{ fontSize: "1.3rem", fontWeight: "500" }}
                          >
                            Price:{" "}
                            <span className="text-warning">{job.workCost}</span>
                            {needsMaterials && (
                              <span
                                className="text-muted ms-2"
                                style={{ fontSize: "1rem" }}
                              >
                                (Additional 1 hour if materials need to be
                                purchased)
                              </span>
                            )}
                          </p>
                          {job.details && (
                            <p
                              className="top-single-meta-details mt-2"
                              style={{ fontSize: "1.2rem", color: "#6c757d" }}
                            >
                              {job.details}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section class="call-to-action">
          <div class="container">
            <div class="row contact-form-manin-row">
              <div
                class="col-12 contact-form-main-col "
                style={{ textAlign: "center" }}
              >
                <button
                  className="ctaButton-white"
                  onClick={handleScheduleClick}
                >
                  Click Here to Schedule An Appointment
                </button>
              </div>
            </div>
          </div>
        </section>
        <Rates />

        <section className="why-different-section py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 text-center">
                <h2 className="fw-bold mb-3">
                  We're Not Just Another Handyman Company — We're a Promise
                  Kept, Over 12,500 Times.
                </h2>
                <p className="lead mb-4">
                  Our numbers tell the story: over 12,500 verified jobs
                  completed for just 6,037 customers.
                  <br />
                  Why so few? Because people trust us — and they come back again
                  and again.
                  <br />
                  We've been in business over 5 years and now, we're doing what
                  most won't: lowering our prices.
                  <br />
                  Not because we have to — because we want to help.
                </p>
                <div className="row justify-content-center">
                  <div className="col-md-6">
                    <div className="bg-warning bg-opacity-25 rounded-3 p-4 mb-3">
                      <h4 className="mb-2">
                        New Pricing{" "}
                        <span className="badge bg-warning text-dark ms-2">
                          as of May 2025
                        </span>
                      </h4>
                      <div className="d-flex justify-content-center gap-4 align-items-center">
                        <div>
                          <div
                            className="fw-bold text-dark"
                            style={{ fontSize: "2rem" }}
                          >
                            $79
                          </div>
                          <div className="small">First Hour</div>
                        </div>
                        <div
                          className="vr bg-dark"
                          style={{ height: "40px" }}
                        ></div>
                        <div>
                          <div
                            className="fw-bold text-dark"
                            style={{ fontSize: "2rem" }}
                          >
                            $69/hour
                          </div>
                          <div className="small">Additional Hours</div>
                        </div>
                      </div>
                      <div className="mt-2 text-muted">
                        Same service. Same guarantee. Just more affordable.
                      </div>
                    </div>
                  </div>
                </div>
                <button
                  className="btn btn-warning btn-lg mt-2"
                  onClick={handleScheduleClick}
                >
                  Book Now at New Rates
                </button>
              </div>
            </div>
          </div>
        </section>
        <section className="py-4 bg-light">
          <div className="container">
            <div className="row justify-content-center text-center">
              <div className="col-md-8">
                <h3 className="text-dark mb-4">Need Multiple Services?</h3>
                <p className="text-muted mb-4">
                  Book multiple services together and save with our hourly rate
                  discounts!
                </p>
                <button
                  className="btn btn-warning btn-lg"
                  onClick={handleScheduleClick}
                >
                  Get a Custom Quote
                </button>
              </div>
            </div>
          </div>
        </section>
        <section className="service-intro-section py-5 bg-light">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-10 text-center">
                <h2 className="fw-bold mb-3">
                  Skilled Work. Fair Pricing. Real Appointments.
                </h2>
                <p className="lead mb-2">
                  Whether it's TV mounting, drywall repair, electrical fixes, or
                  faucet installs — we do the work the right way, on time, and
                  without vague arrival windows. And now, we do it for less.
                  <br />
                  <span className="fw-bold text-warning">
                    First hour: $79
                  </span>{" "}
                  &nbsp;|&nbsp;{" "}
                  <span className="fw-bold text-warning">
                    Every hour after: $69
                  </span>
                  <br />
                  Combine multiple tasks into one visit — maximize your time and
                  savings.
                  <br />
                  <span className="fw-semibold">
                    All work guaranteed by the on-site handyman.
                  </span>
                </p>
                <div className="d-flex flex-wrap justify-content-center gap-3 mt-3">
                  <button
                    className="btn btn-warning btn-lg"
                    onClick={handleScheduleClick}
                  >
                    Book Now at New Rates
                  </button>
                  <button
                    className="btn btn-outline-dark btn-lg"
                    onClick={handleScheduleClick}
                  >
                    Chat with Our AI Assistant 24/7
                  </button>
                  <button
                    className="btn btn-dark btn-lg"
                    onClick={handleScheduleClick}
                  >
                    Fix More for Less – Start Today
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-5 bg-dark text-white">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-6">
                <h3 className="mb-4">Emergency Services Available</h3>
                <p className="mb-4">
                  Don't wait until it's too late. Contact us now for immediate
                  assistance with your home repairs and installations.
                </p>
                <button
                  className="btn btn-warning btn-lg"
                  onClick={handleScheduleClick}
                >
                  Request Emergency Service
                </button>
              </div>
              <div className="col-md-6 text-center">
                <i className="fas fa-tools fa-5x text-warning"></i>
              </div>
            </div>
          </div>
        </section>

        <section class="call-to-act-sect">
          <div class="call-to-act-wrapper">
            <div class="container">
              <div class="row">
                <div class="col-12 call-to-act-main-col">
                  <div class="call-to-act-col-wrapper">
                    <div class="call-act-content">
                      <p class="call-to-act-para">
                        Protect your home by automating your maintenance care
                        plan
                      </p>
                    </div>

                    <div class="call-to-act-btn-div">
                      <a
                        href="https://breakthroughhandyman.com/contact"
                        class="call-to-act-btn-anch"
                      >
                        Get Started Today
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Services;
